import { render, staticRenderFns } from "./MapHot.vue?vue&type=template&id=28156f45&scoped=true&"
import script from "./MapHot.vue?vue&type=script&lang=js&"
export * from "./MapHot.vue?vue&type=script&lang=js&"
import style0 from "./MapHot.vue?vue&type=style&index=0&id=28156f45&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28156f45",
  null
  
)

export default component.exports